import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class HokifyJobsItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            titleLink: '.m-hokifyJobsItem__titleLink',
            companyLink: '.m-hokifyJobsItem__company',
        };
    }

    getPropsFromDom() {
        return {
            id: this.dom.el.getAttribute('data-id'),
            link: this.dom.titleLink.href,
        };
    }

    domEvents() {
        this.dom.companyLink.addEventListener('click', (e) => e.stopPropagation());

        this.dom.el.addEventListener('click', (e) => {
            e.preventDefault();
            window.open(this.props.link);
        });
    }
}
